import React, { useState } from "react";
import CountdownTimer from "./timerComponent";
import { MdOutlineStickyNote2 } from "react-icons/md";
import { Observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

export default function Timer({ interviewId, theme }) {
  const navigate = useNavigate();
  const [showReportButton, setShowReportButton] = useState(false);

  const onClickButton = () => {
    navigate(`/dashboard/report/${interviewId}`, { replace: true });
  };

  return (
    <Observer>
      {() => (
        <div
          className="w-full h-[100%] relative rounded-3xl flex flex-col items-center justify-center"
          style={{
            background: theme === "dark" ? "#000" : "#fff",
            color: theme === "dark" ? "#fff" : "#222",
          }}
        >
          <CountdownTimer
            onComplete={() => {
              setShowReportButton(true);
            }}
          />
          {!showReportButton ? (
            <p className="mt-6 gil-med text-2xl opacity-50">
              {" "}
              Preparing your results Please wait...
            </p>
          ) : (
            <button
              onClick={onClickButton}
              className="mt-3 py-3 px-4 flex flex-row items-center justify-center text-sm h-[50px] w-1/5 gil-bold ml-2 rounded-md bg-green-500 hover:shadow-xl text-white"
            >
              <MdOutlineStickyNote2 size="1.2rem" className="mr-2" /> View
              Report
            </button>
          )}
        </div>
      )}
    </Observer>
  );
}
